import '../scss/notthoff-meilisearch.scss';
import axios from 'axios';
import debounce from 'lodash.debounce';

export function add(a, b) {
    return a - b * 2;
}

// If dom is loaded, output the result of the add function to the console

document.addEventListener('DOMContentLoaded', () => {
    // If search-overlay exists, add event listener to search bar on input event
    const searchOverlay = document.querySelector('.search-overlay');
    if (searchOverlay) {
        // Find search-bar and add event listener
        const searchBar = searchOverlay.querySelector('.search-bar--input');

        const makeSearchRequest = debounce((value, isRepeatedSearch = false) => {
            // Make axios request
            let url = notthoffMeilisearch.root + 'notthoff-meilisearch/v1/search';
            let params = {
                q: value,
                isRepeatedSearch: isRepeatedSearch
            };

            // Add nonce to X-WP-Nonce header
            let headers = {
                'X-WP-Nonce': notthoffMeilisearch.nonce
            };

            // Add class 'searching' to .search-bar-wrapper .center-col
            const searchWrapper = searchOverlay.querySelector('.search-bar-wrapper .center-col');
            searchWrapper.classList.add('searching');

            // Hide translation-hint
            const translationHint = searchWrapper.querySelector('.translation-hint');
            translationHint.classList.remove('was-translated');

            // Make axios request
            axios.get(url, {params, headers})
                .then((res) => {
                    // Set search results as innerHTML of search-results div
                    let searchResults = document.querySelector('.search-results');
                    searchResults.innerHTML = '';

                    searchWrapper.classList.remove('searching');

                    if(res.data['isTranslated']) {

                        // Set content of span
                        translationHint.querySelector('.translated-text').innerHTML = res.data['translatedQuery'];
                        translationHint.querySelector('.source-lang').innerHTML = res.data['sourceLang'];
                        translationHint.classList.add('was-translated');
                    }

                    // If res.data['promotedContent'] has object as value and attribute 'content' is set, display promoted content
                    if (res.data['promotedContent'] && res.data['promotedContent']['content']) {
                        let promotedContent = res.data['promotedContent']['content'];
                        let promotedContentHTML = `
                            <div class="search-results__item search-results__promoted-content">
                                ${promotedContent}
                            </div>
                        `;
                        searchResults.innerHTML += promotedContentHTML;
                    }

                    // If there are results, display them

                    if (res.data['hits'].length > 0) {
                        let resultsHTML = '';
                        res.data['hits'].forEach((result) => {

                            let typeSuffix = '';

                            if (result.isNewsPost === true) {
                                typeSuffix = " (VÖ: " + result.created_at + ")";
                            }


                            resultsHTML += `
                                <a href="${result.permalink}" class="search-results__item">
                                    <div class="thumbnail ${result.isPlaceholder ? 'placeholder-image' : ''}"><img src="${result.thumbnail}" alt="${result.title}"></div>
                                    <div class="excerpt"><strong>${result.title}</strong> &middot; ${result.excerpt}</div>
                                    <div class="meta-data">${result.post_type} ${typeSuffix}</div>
                                </a>
                            `;
                        });
                        searchResults.innerHTML += resultsHTML;
                    }

                    // If there are no results and no promoted content, display no results message
                    if (res.data['hits'].length === 0 && (!res.data['promotedContent'] || !res.data['promotedContent']['content'])) {
                        if (res.data['noResultsText']) {
                            searchResults.innerHTML += `
                            <div class="search-results__item search-results__no-results">
                                ${res.data['noResultsText']}
                            </div>
                        `;
                        }
                    }

                })
                .catch((err) => {
                    searchWrapper.classList.remove('searching');
                    console.log(err);
                });

            // Set search term in session storage
            sessionStorage.setItem('meilisearch_search_term', value);

        }, 250)


        searchBar.addEventListener('input', (e) => {
            // Make sure search bar is not empty

            if (searchBar.value.length > 0) {
                // Debounce search
                makeSearchRequest(searchBar.value);
            } else {
                // Clear search results
                let searchResults = document.querySelector('.search-results');
                searchResults.innerHTML = '';
            }
        });

        // Add event listener to anchor with href #search to open search overlay
        let searchAnchor = document.querySelectorAll('a[href="#search"]');

        searchAnchor.forEach((anchor) => {
            anchor.addEventListener('click', (e) => {
                e.preventDefault();

                // Check if "meilisearch_search_term" is set in session storage
                let search_term = sessionStorage.getItem('meilisearch_search_term');

                // If search term is set and search bar is empty, set search term in search bar
                if (search_term && search_term.length > 0) {
                    let searchBar = document.querySelector('.search-bar--input');
                    searchBar.value = search_term;
                    makeSearchRequest(search_term, true);
                }


                // Add class to body
                document.body.classList.add('search-overlay--active');

                // Add class show to search overlay
                let searchOverlay = document.querySelector('.search-overlay');
                searchOverlay.classList.add('show');

                // Focus on search bar
                let searchBar = document.querySelector('.search-bar--input');
                searchBar.focus();
            });
        });
    }

    // On escape key press, close search overlay, if its open
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            hideSearch();
        }
    });

    // On click on links with #search-close in href, close search overlay
    let searchClose = document.querySelectorAll('a[href="#close-search"]');

    searchClose.forEach((anchor) => {
        anchor.addEventListener('click', (e) => {
            e.preventDefault();
            hideSearch();
        });
    });

    // On click on .close-area inside searchOverlay, close search overlay
    let closeArea = searchOverlay.querySelectorAll('.close-area');

    closeArea.forEach((area) => {
        area.addEventListener('click', (e) => {
            e.preventDefault();
            hideSearch();
        });
    });

    function hideSearch() {
        // Remove class from body
        document.body.classList.remove('search-overlay--active');

        // Remove class show from search overlay
        let searchOverlay = document.querySelector('.search-overlay');
        searchOverlay.classList.remove('show');

        // Clear search bar
        // let searchBar = document.querySelector('.search-bar--input');
        // searchBar.value = '';
        //
        // // Clear search results
        // let searchResults = document.querySelector('.search-results');
        // searchResults.innerHTML = '';
    }
});